import { useMemo } from "react";

import { CategoryEnum } from "@/generated/graphql/graphql";

export function useCategoryKeys() {
  return useMemo<CategoryEnum[]>(
    () => [
      CategoryEnum.Education,
      CategoryEnum.Family,
      CategoryEnum.Life,
      CategoryEnum.Other,
      CategoryEnum.Private,
      CategoryEnum.Sleep,
      CategoryEnum.Work,
      CategoryEnum.Unset,
    ],
    [],
  );
}
